// Path → semantic page name. Drives nw_page_<name> events from usePageTracking.
// Add new entries here when introducing new screens, so analytics stays consistent.

export const PAGE_NAMES = {
  "/": "root",
  "/activate": "activation",
  "/welcome": "welcome",
  "/verification": "verification",
  "/alarm/verify": "alarm_verify",
  "/alarm/survey": "alarm_survey",
  "/alarm/data": "alarm_data",
  "/contact-info": "contact_info",
  "/confirmation-status": "confirmation_status",
  "/survey": "survey",
  "/reward": "reward_redirect",
  "/rewards": "rewards",
  "/rewards-claim": "rewards_claim",
};

export function getPageName(pathname) {
  if (!pathname) return "unknown";
  if (PAGE_NAMES[pathname]) return PAGE_NAMES[pathname];

  // step-based dynamic route handler in App.js
  const stepMatch = pathname.match(/^\/onboarding\/(.+)$/);
  if (stepMatch) return `onboarding_${stepMatch[1].replace(/\//g, "_")}`;

  return null;
}
